// Generated by scripts/generate-public-env.mjs. This file contains browser-safe values only.
export const rawPublicEnv = {
  APP_NAME: "niobiumecomm-ptrb-vol-test",
  TENANT_ID: "de8b3e50-abf6-4cdd-9269-f2472a1020ad",
  GOOGLE_RECAPTCHA_SITE_KEY: "6Lc0jFgrAAAAAIqRdx-gR0yaFs5Nhx8DnvqLzY9R",
  STORE_INTEGRATION_ENDPOINT: "https://staging.api.store.niobium.co.nz",
  NOTIFICATION_INTEGRATION_ENDPOINT: "https://staging.api.notification.niobium.co.nz",
  STRIPE_PUBLIC_KEY: "pk_test_51RSwkoRt21XMpal88MegWydqv4YnluqxPMXXCrh0EGbYJEUokmgwZkHxf18BiCrurjrRaWbqwf0hygdKUBdo5IlP00s8EmNX99",
  SHIPPING_OPTION_ID: "1",
  TARGET_COUNTRY: "AU",
  FALLBACK_COUPON: "BUNDLESAVE",
  OFFER_OPTION__1: "[{\"Listing\":1,\"Option\":\"Default\",\"Quantity\":1}]",
  OFFER_OPTION__2: "[{\"Listing\":1,\"Option\":\"Default\",\"Quantity\":2},{\"Listing\":2,\"Option\":\"Default\",\"Quantity\":4}]",
  OFFER_OPTION__3: "[{\"Listing\":1,\"Option\":\"Default\",\"Quantity\":3}]",
  META_PIXEL_ID: "1225432212563029",
  GOOGLE_TAG: "G-E5ZVT43LYM",
  CLARITY_ID: "t6zjrfru2y",
  FACEBOOK_URL: "https://www.facebook.com/niobiumstudionz",
  INSTAGRAM_URL: "https://www.instagram.com/niobium_studio",
  CONTACT_EMAIL: "support@niobium.co.nz",
} as const;
